import React from 'react'
import { get } from 'lodash'
import { gql, useQuery } from '@apollo/client'
import { Link } from 'react-router-dom'

import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import InfoOutlinedIcon from 'components/material-symbol/icons/Info'
import LibraryBooksIcon from 'components/material-symbol/icons/LibraryBooks'

import ActionTile from 'components/action-tile'
import BookingTypesView from '../booking-types/booking-types-view'
import GroupEventsPanel from '../events/group-events-panel'
import { useStyles } from './styles'
import { OFFERINGS_TAB } from './routes'

const GET_AVAILABILITY = gql`
  query CoachAvailability {
    coachAvailabilities {
      coachFacility {
        id
        name
      }
      startDate
      timeZone
      timeSlots {
        day
        startTime
        endTime
      }
    }
  }
`

const OfferingsPage = ({
  selectedTab,
  hasCoachProfile,
  setShouldShowBookingTypeDisclaimer,
  groupEventsPanel,
}) => {
  const { data, loading } = useQuery(GET_AVAILABILITY)
  const classes = useStyles()
  const availabilities = get(data, 'coachAvailabilities', [])
  const showSetAvailabilityTooltip =
    !loading && !availabilities?.some(a => a.timeSlots.length > 0)

  const bookingTypeContent = (() => {
    if (hasCoachProfile) {
      return (
        <Grid container>
          <BookingTypesView
            setShouldShowDisclaimer={setShouldShowBookingTypeDisclaimer}
          />
        </Grid>
      )
    }

    return (
      <ActionTile
        className={classes.disabledActionTile}
        icon={LibraryBooksIcon}
        headlineText="Booking Type"
        captionText="Before publishing your booking type, please make sure you have **first created your Coach Profile**."
        callToAction={
          <Button
            component={Link}
            to="/pga-coach/profile"
            variant="contained"
            color="primary"
            data-cy="see-coach-booking-types"
          >
            Go To Coach Profile
          </Button>
        }
      />
    )
  })()

  return (
    <Container className={classes.root}>
      {showSetAvailabilityTooltip ? (
        <Box className={classes.tipBannerWrapper}>
          <Box className={classes.tipBanner}>
            <Box className={classes.tipBannerCopy}>
              <InfoOutlinedIcon
                className={classes.tipBannerIcon}
                fontSize="small"
                opticalSize={20}
              />
              <Typography component="span" className={classes.tipBannerText}>
                Set your availability at each location before creating coach
                offerings.
              </Typography>
            </Box>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/pga-coach/settings/availability"
              className={classes.tipBannerButton}
            >
              Set Availability
            </Button>
          </Box>
        </Box>
      ) : null}
      {selectedTab === OFFERINGS_TAB.BOOKING_TYPE ? (
        <Box className={classes.tabContent}>{bookingTypeContent}</Box>
      ) : (
        <Box className={`${classes.groupEventsWrapper} ${classes.tabContent}`}>
          <GroupEventsPanel panel={groupEventsPanel} showInlineTabs />
        </Box>
      )}
    </Container>
  )
}

export { OFFERINGS_TAB, getOfferingsPath, parseOfferingsTab } from './routes'
export default OfferingsPage
